// ===== ARCHITECTURE & DESIGN (NATA) =====
const ARCHITECTURE = [
  {
    id: "barch",
    name: "B.Arch (Bachelor of Architecture)",
    stream: "science",
    category: "architecture",
    summary:
      "Five-year program in architecture focusing on design, planning, construction technology, and sustainable development.",
    eligibility:
      "10+2 with PCM (minimum 50%); must qualify NATA or JEE Paper 2 (B.Arch).",
    exams: ["NATA", "JEE Main Paper 2"],
    colleges: [
      "School of Planning & Architecture (SPA), Delhi",
      "CEPT University, Ahmedabad",
      "Sir JJ College of Architecture, Mumbai",
      "Manipal School of Architecture",
      "Chandigarh College of Architecture"
    ],
    source: "Council of Architecture official site (NATA).",
    keywords: ["architecture", "barch", "design", "planning"],
  },
  {
    id: "bplan",
    name: "B.Plan (Bachelor of Planning)",
    stream: "science",
    category: "architecture",
    summary:
      "Four-year program focusing on urban planning, transport planning, environmental planning, and policy-making.",
    eligibility:
      "10+2 with PCM; JEE Paper 2 or institute-specific test.",
    exams: ["JEE Main Paper 2"],
    colleges: [
      "School of Planning & Architecture (SPA), Delhi",
      "CEPT University, Ahmedabad",
      "NITs (B.Plan Programs)"
    ],
    source: "Council of Architecture & NIT websites.",
    keywords: ["planning", "urban", "policy", "development"],
  },
  {
    id: "bdes",
    name: "B.Des (Bachelor of Design) - Architecture Specialization",
    stream: "science",
    category: "architecture",
    summary:
      "Four-year program combining design, architecture principles, and sustainable solutions.",
    eligibility:
      "10+2 with PCM/Any Stream; NATA or UCEED accepted in some colleges.",
    exams: ["NATA", "UCEED"],
    colleges: [
      "NID Ahmedabad",
      "MIT Institute of Design",
      "CEPT University"
    ],
    source: "NATA & UCEED official notifications.",
    keywords: ["design", "architecture", "bdes", "innovation"],
  },
];

export default ARCHITECTURE;
